// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../../_common/common.utils';
import AdvanceMemberActionType from './advance-member.types';

const INITIAL_STATE = {
	// Fetch Advance Member List
	fetchAdvanceMemberListResp: null,
	fetchAdvanceMemberListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH ADVANCE MEMBER LIST START *********************** */
		case AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_SUCCESS:
			return {
				...state,
				fetchAdvanceMemberListResp: action.payload,
				fetchAdvanceMemberListArr: docodeHexResponse(action.payload, 'MemberDetailsKey'),
			};

		case AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_FAILURE:
			return {
				...state,
				fetchAdvanceMemberListResp: action.payload,
				fetchAdvanceMemberListArr: [],
			};

		case AdvanceMemberActionType.FETCH_ADVANCE_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, fetchAdvanceMemberListResp: null, fetchAdvanceMemberListArr: [] };
		/** ***************** FETCH ADVANCE MEMBER LIST END *********************** */
		default:
			return state;
	}
};
